// extracted by mini-css-extract-plugin
export default {"tableScroll":"styles_tableScroll__IL-DU","listIcon":"styles_listIcon__eE3Ng","tableIcon":"styles_tableIcon__SemyU"};